import { ApartmentDto } from "@/api/models/coverage.model";
import { CustomerHandoverProcessDto } from "@/api/models/customer/customerHandover.model";
import { handoverInitialState, HandoverState } from "./handover";
import { HANDOVER_MUTATION_TYPES } from "./constants";
import { Identification } from "@/api/models/sale/identification.model";
import { BusinessType } from "@/api/constants/enums";

const SET_HANDOVER_APARTMENT = (state: HandoverState, apartment: ApartmentDto): void => {
	state.apartment = apartment;
};

const SET_HANDOVER_TYPE = (state: HandoverState, handoverType: string): void => {
	state.handoverType = handoverType;
};

const SET_HANDOVER_PROCESS = (state: HandoverState, process: CustomerHandoverProcessDto): void => {
	state.process = process;
};

const SET_LOADING = (state: HandoverState, loading: boolean): void => {
	state.loading = loading;
};

const SET_ERROR = (state: HandoverState, error: string): void => {
	state.error = error;
};

const CLEAR_ERROR = (state: HandoverState): void => {
	state.error = undefined;
};

const SET_HANDOVER_ID = (state: HandoverState, handoverId: number): void => {
	if (!state.process) {
		state.process = {} as CustomerHandoverProcessDto;
	}
	state.process.id = handoverId;
};

const UPDATE_HANDOVER_NOTES = (state: HandoverState, notes: string): void => {
	if (state.process) {
		state.process.notes = notes;
	}
};

const UPDATE_HANDOVER_BILLING_FIRST_NAME = (state: HandoverState, value: string): void => {
	if (state.process) {
		if (state.process.billing) {
			state.process.billing.firstName = value;
		}
	}
};

const UPDATE_HANDOVER_BILLING_LAST_NAME = (state: HandoverState, value: string): void => {
	if (state.process) {
		if (state.process.billing) {
			state.process.billing.lastName = value;
		}
	}
};

const UPDATE_HANDOVER_BILLING_IBAN = (state: HandoverState, value: string): void => {
	if (state.process) {
		if (state.process.billing) {
			state.process.billing.iban = value;
		}
	}
};

const UPDATE_HANDOVER_BILLING_ADDRESS_DATA = (state: HandoverState, value: any): void => {
	if (state.process) {
		if (state.process.billing) {
			state.process.billing.addressData = value;
		}
	}
};

const UPDATE_HANDOVER_BUSINESS_TYPE = (state: HandoverState, type: BusinessType): void => {
	if (state.process) {
		if (state.process.business) {
			state.process.business.type = type;
		}
	}
};

const UPDATE_HANDOVER_BUSINESS_LEGAL_NAME = (state: HandoverState, legalName: string): void => {
	if (state.process) {
		if (state.process.business) {
			state.process.business.legalName = legalName;
		}
	}
};

const UPDATE_HANDOVER_BUSINESS_TRADING_NAME = (state: HandoverState, tradingName: string): void => {
	if (state.process) {
		if (state.process.business) {
			state.process.business.tradingName = tradingName;
		}
	}
};

const UPDATE_HANDOVER_BUSINESS_IDENTIFICATION = (state: HandoverState, identification: Identification): void => {
	if (state.process) {
		if (state.process.business) {
			state.process.business.identification = identification;
		}
	}
};

const UPDATE_HANDOVER_CUSTOMER_DATA = (state: HandoverState, customerData: any): void => {
	if (state.process) {
		const { mobilePhone, ...customerFields } = customerData;

		state.process.customer = { ...state.process.customer, ...customerFields };

		if (mobilePhone !== undefined) {
			(state.process as any).customer.mobilePhone = mobilePhone;
		}

		if ((!state.process.billing || !state.process.billing.firstName) && customerData.firstName) {
			state.process.billing = {
				...state.process.billing,
				firstName: customerData.firstName
			};
		}
		if ((!state.process.billing || !state.process.billing.lastName) && customerData.lastName) {
			state.process.billing = {
				...state.process.billing,
				lastName: customerData.lastName
			};
		}
	}
};

const UPDATE_HANDOVER_CUSTOMER_IDENTIFICATION = (state: HandoverState, identification: Identification): void => {
	if (state.process) {
		if (state.process.customer) {
			state.process.customer.identification = identification;
		}
	}
};

const CLEAR_HANDOVER = (state: HandoverState): void => {
	Object.assign(state, handoverInitialState());
};

export default {
	[HANDOVER_MUTATION_TYPES.SET_HANDOVER_APARTMENT]: SET_HANDOVER_APARTMENT,
	[HANDOVER_MUTATION_TYPES.SET_HANDOVER_TYPE]: SET_HANDOVER_TYPE,
	[HANDOVER_MUTATION_TYPES.SET_HANDOVER_PROCESS]: SET_HANDOVER_PROCESS,
	[HANDOVER_MUTATION_TYPES.SET_LOADING]: SET_LOADING,
	[HANDOVER_MUTATION_TYPES.SET_ERROR]: SET_ERROR,
	[HANDOVER_MUTATION_TYPES.CLEAR_ERROR]: CLEAR_ERROR,
	[HANDOVER_MUTATION_TYPES.SET_HANDOVER_ID]: SET_HANDOVER_ID,
	[HANDOVER_MUTATION_TYPES.UPDATE_HANDOVER_NOTES]: UPDATE_HANDOVER_NOTES,
	[HANDOVER_MUTATION_TYPES.UPDATE_HANDOVER_CUSTOMER_DATA]: UPDATE_HANDOVER_CUSTOMER_DATA,
	[HANDOVER_MUTATION_TYPES.UPDATE_HANDOVER_CUSTOMER_IDENTIFICATION]: UPDATE_HANDOVER_CUSTOMER_IDENTIFICATION,
	[HANDOVER_MUTATION_TYPES.UPDATE_HANDOVER_BILLING_FIRST_NAME]: UPDATE_HANDOVER_BILLING_FIRST_NAME,
	[HANDOVER_MUTATION_TYPES.UPDATE_HANDOVER_BILLING_LAST_NAME]: UPDATE_HANDOVER_BILLING_LAST_NAME,
	[HANDOVER_MUTATION_TYPES.UPDATE_HANDOVER_BILLING_IBAN]: UPDATE_HANDOVER_BILLING_IBAN,
	[HANDOVER_MUTATION_TYPES.UPDATE_HANDOVER_BILLING_ADDRESS_DATA]: UPDATE_HANDOVER_BILLING_ADDRESS_DATA,
	[HANDOVER_MUTATION_TYPES.UPDATE_HANDOVER_BUSINESS_TYPE]: UPDATE_HANDOVER_BUSINESS_TYPE,
	[HANDOVER_MUTATION_TYPES.UPDATE_HANDOVER_BUSINESS_LEGAL_NAME]: UPDATE_HANDOVER_BUSINESS_LEGAL_NAME,
	[HANDOVER_MUTATION_TYPES.UPDATE_HANDOVER_BUSINESS_TRADING_NAME]: UPDATE_HANDOVER_BUSINESS_TRADING_NAME,
	[HANDOVER_MUTATION_TYPES.UPDATE_HANDOVER_BUSINESS_IDENTIFICATION]: UPDATE_HANDOVER_BUSINESS_IDENTIFICATION,
	[HANDOVER_MUTATION_TYPES.CLEAR_HANDOVER]: CLEAR_HANDOVER
};
